import {
  TextField as MuiTextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import { ReactElement } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

import { FlexBox } from "~frontend/components/FlexBox";
import theme from "~frontend/theme";

export function RhfNumberField<T extends FieldValues>(
  props: TextFieldProps &
    UseControllerProps<T> & {
      optional?: boolean;
      bottomLabel?: string;
      max?: number;
    }
): ReactElement {
  const { field, fieldState } = useController(props);

  return (
    <MuiTextField
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value ?? ""}
      name={field.name}
      inputRef={field.ref}
      error={Boolean(fieldState.error)}
      helperText={
        fieldState.error ? fieldState.error.message : props.bottomLabel
      }
      {...(props as TextFieldProps)}
      label={
        <FlexBox
          sx={{ width: "100%" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <FlexBox alignItems="center" gap={1}>
            {props.label}
            {props.optional ? <Typography> (optional)</Typography> : ""}
          </FlexBox>
        </FlexBox>
      }
      slotProps={{
        inputLabel: {
          sx: { width: "133%", maxWidth: `calc(140% - ${theme.spacing(4)})` },
          shrink: true,
          ...(props.InputLabelProps || props.slotProps?.inputLabel || {}),
        },
        input: {
          ...(props.InputProps || props.slotProps?.input || {}),
        },
      }}
    />
  );
}
